module.exports = __webpack_public_path__ + "static/img/5.03fb86e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/5.png
// module id = Hhel
// module chunks = 0